import { Component, OnInit, ChangeDetectorRef } from '@angular/core';
import { MenuController } from '@ionic/angular';
import { data } from 'jquery';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { AppSettings } from 'src/app/enums/app-settings.enum';
import { AdobeAnalyticsService } from 'src/app/services/adobe-analytics.service';
import { FilterDataService } from 'src/app/services/filter-data.service';
import { GoogleAnalyticsService } from 'src/app/services/google-analytics.service';
import { ProductService } from 'src/app/services/product.service';
import { SubjectService } from 'src/app/services/subject.service';
import { UtilitiesService } from 'src/app/utilities/utilities.service';

@Component({
  selector: 'app-filter',
  templateUrl: './filter.component.html',
  styleUrls: ['./filter.component.scss'],
})
export class FilterComponent implements OnInit {
  public form = [
    { val: 'Pepperoni', isChecked: true },
    { val: 'Sausage', isChecked: false },
    { val: 'Mushroom', isChecked: false },
  ];
  public filters: any;
  unsubscribe$: Subject<boolean> = new Subject();
  private selectedFilter: any;
  count = [];
  selectedFilters = [];
  checkedIdx = [];
  constructor(
    private menu: MenuController,
    private cdr: ChangeDetectorRef,
    private GAS: GoogleAnalyticsService,
    private AAS: AdobeAnalyticsService,
    private SS: SubjectService,
    private UTS: UtilitiesService,
    private PS: ProductService,
    private FDS: FilterDataService
  ) {}
  ngOnInit() {
    this.SS.resetFilter
      .pipe(takeUntil(this.unsubscribe$))
      .subscribe((reset) => {
        if (reset && reset == true) {
          this.selectedFilter = null;
          this.filters = [];
          this.count = [];
          this.selectedFilters = [];
          this.checkedIdx = [];
        }
      });
    this.SS.filteredData
      .pipe(takeUntil(this.unsubscribe$))
      .subscribe((f: any) => {
        if (f) {
          for (let i = 0; i < this.checkedIdx.length; i++) {
            if (this.checkedIdx[i] >= 0) {
              return false;
            }
          }
          this.filters = f;
          if (this.filters && this.filters.length && this.filters.length > 0) {
            for (let i = 0; i < this.filters.length; i++) {
              for (let j = 0; j < this.filters[i].dimensionValues.length; j++) {
                this.checkedIdx[i] = -1;
              }
            }
          }
        }
      });
    this.SS.filteredItemsData
      .pipe(takeUntil(this.unsubscribe$))
      .subscribe((f: any) => {
        if (f) {
          this.regenerateFilter(f);
        }
      });
  }
  ngOnDestroy() {
    this.unsubscribe$.next(true);
    this.unsubscribe$.complete();
  }
  async ionViewDidEnter() {}

  openEnd() {
    this.menu.open('end');
  }

  closeMenu() {
    this.menu.close();
  }
  piIndex = -1;
  pjIndex = -1;
  filterSelection(f: any, index: number, filter_type: any, jIndex: number) {
    if (this.piIndex == index && this.pjIndex == jIndex) {
      return false;
    }
    const selectedFilters = JSON.parse(JSON.stringify(this.selectedFilters));

    for (let i = 0; i < selectedFilters.length; i++) {
      if (selectedFilters[i]['dimensionValueID'] == f.dimensionValueID) {
        this.selectedFilters.splice(index, i);
        this.count.pop();
      }
    }
    if (this.selectedFilters.length < selectedFilters.length) return false;
    this.count.push(index);
    this.filters[index].dimensionValues[jIndex]['isSelected'] =
      !this.filters[index].dimensionValues[jIndex]['isSelected'];
    this.selectedFilters.push({ ...f, ...{ filter_type: filter_type } });
    this.selectedFilter = this.filters[index].dimensionValues[jIndex];
    this.getSelectedSubCategory(null, this.selectedFilter.navigationState);
    this.piIndex = index;
    this.pjIndex = jIndex;
    this.cdr.detectChanges();
  }
  applyFilter() {
    if (
      this.selectedFilter &&
      this.selectedFilters &&
      this.selectedFilter.value &&
      this.selectedFilters.length > 0
    ) {
      this.count = [...new Set(this.count)];
      this.selectedFilters = this.UTS.uniqByKeepLast(
        this.selectedFilters,
        (x) => x.filter_type
      );
      this.GAS.filter(this.selectedFilter.value);
      this.AAS.filter(this.selectedFilter.value);
      this.SS.selectedFilter.next({
        NS: this.selectedFilter.navigationState,
        C: this.count.length,
        SF: this.selectedFilters,
      });
    }
    this.menu.close();
  }
  async resetFilter() {
    this.GAS.filter('All');
    this.AAS.filter('All');
    this.SS.selectedFilter.next({
      NS: AppSettings.RESET_FILTER,
      C: 0,
      SF: null,
    });
    //  this.menu.close();
    setTimeout(() => {
      const filters = JSON.parse(JSON.stringify(this.FDS.get()));
      this.selectedFilter = null;
      this.filters = [];
      this.filters = filters;
      this.count = [];
      this.selectedFilters = [];
      this.checkedIdx = [];
      this.piIndex = -1;
      this.pjIndex = -1;
    }, 500);
  }
  private async getSelectedSubCategory(ID: string, NS: string) {
    this.PS.getProductsByCategory(
      this.UTS.getLocaleLanguage(),
      AppSettings.IS_APPLY_DEFAULT_FILTERS,
      ID,
      NS,
      AppSettings.NO
    ).subscribe((data: any) => {
      const f = data.filters.filter(
        (x: any) => x.dimensionName != 'parentCategory.displayName'
      );
      if (f) {
        this.regenerateFilter(f);
      }
    });
  }

  regenerateFilter(filters) {
    const oldFilter = JSON.parse(JSON.stringify(this.FDS.get()));
    let newFilter = [];
    for (let i = 0; i < filters.length; i++) {
      for (let j = 0; j < filters[i].dimensionValues.length; j++) {
        for (let k = 0; k < oldFilter.length; k++) {
          for (let l = 0; l < oldFilter[k].dimensionValues.length; l++) {
            if (
              filters[i].dimensionValues[j]['dimensionValueID'] ==
              oldFilter[k].dimensionValues[l]['dimensionValueID']
            ) {
              newFilter[k] = { ...filters[i], ...oldFilter[k] };
            }
          }
        }
      }
    }
    if (newFilter && newFilter.length > 0) {
      this.filters = [];
      this.filters = newFilter;
    }

    this.cdr.detectChanges();
  }
}
